export default class ScrollTo {

    constructor() {
        this.scrollToElements = document.querySelectorAll('.anchor_list > li');
    }

    init() {
        if(this.scrollToElements) {
            this.scrollToSectionEvent();
        }
    }

    scrollToSectionEvent() {
        this.scrollToElements.forEach((v,i)=>{
            let a = v.querySelector('a');
            if(a){
                a.addEventListener('click', function(e){
                    e.preventDefault();
                    let id = a.getAttribute('href');
                    let section = document.querySelector(id);
                    if(section){
                        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                });
            }
        });
    }
}